// extracted by mini-css-extract-plugin
module.exports = {"playbackRateControl":"PlaybackRateControl_playbackRateControl__256Zg","level":"PlaybackRateControl_level__2kraG","active":"PlaybackRateControl_active__1JTrJ"};